import classNames from 'classnames';
import styled from 'styled-components';

import { Color } from 'style/types';

import { switchCss } from './ui';

const Wrapper = styled.span<{ $backgroundColor?: Color }>`
  ${switchCss}
`;

type Props = {
  size: 'small' | 'default';
  checked: boolean;
  backgroundColor?: Color;
};

export const SwitchIcon = ({ size, checked, backgroundColor }: Props) => {
  return (
    <Wrapper
      className={classNames(size)}
      aria-checked={checked}
      $backgroundColor={backgroundColor}
    />
  );
};
